import {ChangeDetectionStrategy, Component, Input, OnInit} from "@angular/core";
import {AuditType, getProcessTypeForStandard, Order, ProcessType, Product} from "../../../store/state/order.state";
import {CurrentCertificationBodyQuestionsFormService} from "./current-certification-body-questions-form-service";
import {FormGroup} from "@angular/forms";
import {BaseSubFormComponent} from "../../../umbrella-common/components/base-sub-form.component";
import {Actions, ofType} from "@ngrx/effects";
import {OrderActions} from "../../../store/actions/order.actions";
import {filter} from "rxjs/operators";

@Component({
    selector: 'current-cb-questions',
    templateUrl: './current-certification-body-questions.template.html',
    styleUrls: ['./current-certification-body-questions.style.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class CurrentCertificationBodyQuestionsComponent extends BaseSubFormComponent implements OnInit {

	readonly INITIAL_CERTIFICATION_AUDIT_TYPE: AuditType = AuditType.INITIAL_CERTIFICATION;
	readonly SURVEILLANCE_1_AUDIT_TYPE: AuditType = AuditType.SURVEILLANCE_1;
	readonly SURVEILLANCE_2_AUDIT_TYPE: AuditType = AuditType.SURVEILLANCE_2;
	readonly RECERTIFICATION_AUDIT_TYPE: AuditType = AuditType.RECERTIFICATION;

	@Input() order: Order;
	@Input() product: Product;
	@Input() certificationBodies: string[];
	@Input() blocked: boolean = false;

	form: FormGroup;
	otherCbChosen: boolean = false;

	constructor(private formService: CurrentCertificationBodyQuestionsFormService, private actions$: Actions) {
		super(formService);
	}

	ngOnInit(): void {
		this.form = this.formService.buildSubForm(this.product.standard.name, this.totalSubForms(this.order), this.product, this.certificationBodies);
		this.actions$.pipe(
			ofType(OrderActions.SET_HAS_ISO_CERTIFICATE),
			filter(action => action.standardName == this.product.standard.name && !action.hasCertificate)
		).subscribe(() => this.formService.clearAllData(this.product.standard.name));
	}

	getFormKey(): string {
		return this.standardName;
	}

	get standardName(): string {
		return this.product.standard.name;
	}

	searchCertificationBodiesFn(searchString: string, body: string): boolean {
		return body.toLowerCase().trim().includes(searchString.toLowerCase().trim());
	}

	shouldDisableRadio(controlNamePrefix: string): boolean {
		return this.formService.getFormControl(this.product.standard.name, this.fullControlName(controlNamePrefix)).disabled;
	}

	get dekraTypedAsCustomCb(): boolean {
		return !!this.product.standard.otherCbName && this.product.standard.otherCbName.toLowerCase().includes('dekra');
	}

	onCbChange(option: string) {
		this.otherCbChosen = option !== this.certificationBodies[this.certificationBodies.length-1];
	}

	protected iso27701HasItsOwnSubForm(): boolean {
		return true;
	}

	override totalSubForms(order: Order): number {
		return order.products.filter(p => getProcessTypeForStandard(p.standard) == ProcessType.TRANSFER).length;
	}
}
